import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  Divider,
  useTheme,
  Alert,
} from "@mui/material";
import Button from "../../common/Button";
import { useForm } from "react-hook-form";
import { tokens } from "../../../theme";
import { useLocation } from "react-router-dom";
import CustomPasswordTextField from "../../common/CustomPasswordTextField";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { authenticateExternalLink, updateElementInDocumentSlice, useDocumentReducer } from "../../../redux/slice/document/DocumentSlice";
import { setSingleAlertObj, SingleAlertInfo } from "../../../redux/slice/commonSlice";

interface DocumentAccessPopupProps {
  onClose: () => void;
  open: boolean;
}

const DocumentAccessPopup: React.FC<DocumentAccessPopupProps> = ({
  onClose,
  open,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const { control } = useForm();
  const dispatch = useAppDispatch();
  const { authenticateExternalLinkStatus } = useDocumentReducer();

  const [password, setPassword] = React.useState("");

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const password: string = data.get("password") as string;
    const email: string = "test@v3.com";
    handleAccess(email, password);
  };

  const handleAccess = async (userName: string, password: string) => {
    dispatch(authenticateExternalLink(
      {
        interceptorOption: { skipErrorPopup: true },
        password: password,
      }
    ));
  };

  useEffect(() => {
    if( authenticateExternalLinkStatus === 'success' ) {
      onClose();
      dispatch(updateElementInDocumentSlice({
        elementName: "authenticateExternalLinkStatus",
        value: "idle"
      }));
    } else if(authenticateExternalLinkStatus === 'error') {
    let errorObj: SingleAlertInfo = {
      message: "Invalid Password",
      alertType: "error"
    };
    dispatch(setSingleAlertObj(errorObj));
    dispatch(updateElementInDocumentSlice({
      elementName: "authenticateExternalLinkStatus",
      value: "idle"
    }));
    };
  }, [authenticateExternalLinkStatus]);

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: "20px",
          padding: "20px",
          minWidth: "400px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.8)",
        },
      }}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          backdropFilter: "blur(2px)",
        },
      }}
    >
      <DialogContent>
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <img
            src={require("../../../assets/document_icon.png")}
            alt="document Icon"
            style={{ width: 35, height: 35, marginRight: "0.5rem" }}
          />
          Document List
        </Typography>

        <Typography variant="body2" sx={{ marginBottom: "1rem" }}>
          Please enter your password for Accessing Document List
        </Typography>

        <Divider sx={{ mb: "1rem" }} />

        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <Box sx={{ marginBottom: "1.5rem" }}>
            <Typography variant="body2">Password</Typography>
            <CustomPasswordTextField
              control={control}
              margin="normal"
              fullWidth
              controllerName="password"
              label="Password"
              id="password"
              autoComplete="current-password"
              sx={{ borderRadius: 2 }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Box>
          <Box sx={{ justifyContent: "center" }}>
            <Button variant="contained" type="submit" fullWidth>
              Access Document List
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentAccessPopup;
